import styled from 'styled-components';
import { media } from 'utils/rwd';

export const Grid = styled.div`
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  ${media.xs`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${media.md`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${media.xl`
    grid-template-columns: repeat(4, 1fr);
  `}
`;

export const Card = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  align-items: center;
  aspect-ratio: 3/4;
  padding: 24px;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
`;

export const Title = styled.h2`
  text-align: center;
  font-size: 1.25rem;
  margin-bottom: 16px;
`;

export const IconWrapper = styled.div`
  min-height: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    display: block;
  }
`;
